// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { TvBaseFormatter } from './TvBaseFormatter';
import { InstrumentUtils } from '@shared/utils/Instruments/InstrumentUtils';
import { ProductType } from '@shared/utils/Instruments/ProductType';
import { TvAccountHelper } from '../Helpers/TvAccountHelper';
export class TvQuantityFormatter extends TvBaseFormatter {
    constructor(symbol) {
        super(symbol);
        this.productType = ProductType.General;
        this.account = TvAccountHelper.getCurrentAccount();
    }
    format(value) {
        if (this.instrument != null)
            return InstrumentUtils.formatAmountValue(value, this.instrument, this.account, this.productType);
        return value.toString();
    }
}
